import {DashboardUsageChart} from './DashboardUsageChart';

export default DashboardUsageChart;
